'use client';

import { useMemo } from 'react';
import Cookies from 'js-cookie';
import './AOSBanner.scss';
import { decodeJwt, useUserSession } from '@libs/common-next';
import { usePathname } from 'next/navigation';

export function AOSBanner() {
    const { user } = useUserSession();
    const oktaAccessToken = Cookies.get('oktaAccessToken');
    const pathname = usePathname();
    const isCheckout = pathname === '/checkout';

    const decodedJwt = decodeJwt(user?.oktatoken ?? oktaAccessToken);

    const userName = useMemo(() => {
        if (decodedJwt && typeof decodedJwt.payload !== 'string' && decodedJwt?.payload.sub) {
            return decodedJwt.payload.sub.split('@')[0];
        }
        return null;
    }, [decodedJwt]);

    return (
        !isCheckout &&
        (oktaAccessToken || user?.oktatoken) && (
            <div className="aos__banner">
                <p>CALL CENTER SESSION</p>

                {userName && (
                    <>
                        <div />
                        <p>Client ID: {userName}</p>
                    </>
                )}
            </div>
        )
    );
}
